module.exports = __webpack_public_path__ + "img/betgame.3f33974e.png";